import React from 'react'

import AuthManager from '../utils/AuthManager'

import CRMEngagementCard from './components/cards/CRMEngagementCard'
import CRMBoard from './components/board/CRMBoard'


export default class MobileCRM extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
    }
  }

  render() {

    if (false && AuthManager.currentWebsite.leads_no === 0) {
      return (
        <div className="row">
          <CRMEngagementCard />
        </div>
      )
    }

    return (
      <div className='mobile-crm'>
        <CRMBoard/>
      </div>
    )
  }
}
